/*
  <carousel-element> — Concept's Flickity wrapper (theme.js CarouselElement),
  ported without the Concept runtime: IntersectionObserver replaces
  Motion.inView for the lazy init, and there are no theme.* dependencies.

  With the `watch-css` attribute, Flickity's watchCSS option reads the
  element's ::after content — 'flickity' activates the carousel (draggable,
  wrap-around, page dots), 'none' dissolves it back into normal flow/grid.
  CSS media queries therefore decide at which widths it's a carousel; see
  sections/trust-badges.liquid for the pattern.

  Requires assets/flickity.pkgd.min.js (v2.3.0), loaded before this file.
*/
(function () {
  if (customElements.get('carousel-element')) return;

  customElements.define(
    'carousel-element',
    class CarouselElement extends HTMLElement {
      connectedCallback() {
        if (this.observed) return;
        this.observed = true;

        // Defer init until the carousel scrolls near the viewport (Concept
        // uses Motion.inView with the same 200px margin).
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.io.disconnect();
                this.io = null;
                this.init();
              }
            },
            { rootMargin: '200px 0px 200px 0px' }
          );
          this.io.observe(this);
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.carousel) {
          this.carousel.destroy();
          this.carousel = null;
        }
        // Editor re-renders detach and reattach sections — allow a re-init.
        this.observed = false;
        this.initialized = false;
      }

      init() {
        if (this.initialized || typeof Flickity === 'undefined') return;
        this.initialized = true;

        const items = Array.from(this.children);
        if (items.length < 2) return;

        this.carousel = new Flickity(this, {
          watchCSS: this.hasAttribute('watch-css'),
          prevNextButtons: false,
          adaptiveHeight: true,
          wrapAround: true,
          initialIndex: parseInt(this.getAttribute('initial-index') || '0', 10),
        });

        if (window.Shopify && Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            this.carousel.select(items.indexOf(event.target));
          });
        }
      }
    }
  );
})();
